export default function abbreviateNumber(number: number) {
  const splitNumber = number.toString().split('');
  let formattedNumber = number.toString();
  let abbr = '';

  if (number >= 1000000) {
    abbr = 'M';
    formattedNumber = `${splitNumber[0]}.${splitNumber[1]}`;
  } else if (number >= 100000) {
    formattedNumber = `${splitNumber[0]}${splitNumber[1]}${splitNumber[2]}`;
    abbr = 'K';
  } else if (number >= 999) {
    formattedNumber = `${splitNumber[0]}${splitNumber[1]}`;
    abbr = 'K';
  }

  return `${formattedNumber}${abbr}`;
}
